import { SET_LEDGER_ENV } from "../actions/ledger-env-actions";

const STORAGE_KEY = "ledger:environment";

const readInitialEnv = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === "SANDBOX" ? "SANDBOX" : "LIVE";
  } catch {
    return "LIVE";
  }
};

const initialState = {
  environment: readInitialEnv(),
};

const LedgerEnvReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEDGER_ENV:
      try {
        localStorage.setItem(STORAGE_KEY, action.payload);
      } catch {
        // storage unavailable, keep redux as source of truth for the session
      }
      return { ...state, environment: action.payload };
    default:
      return state;
  }
};

export default LedgerEnvReducer;
